import axios from '../../helpers/axios';

export const fetchSystemMonitor = async (historyMinutes = 60) => {
  const response = await axios.get('/admin/system-monitor', { params: { historyMinutes } });
  return response.data;
};

export const fetchSystemAnalytics = async ({ source = 'all', days = 7 } = {}) => {
  const response = await axios.get('/admin/system-monitor/analytics', { params: { source, days } });
  return response.data;
};


export const fetchSystemVisitors = async ({ source = 'all', days = 1, limit = 250 } = {}) => {
  const response = await axios.get('/admin/system-monitor/visitors', { params: { source, days, limit } });
  return response.data;
};

export const fetchSystemVisitorHistory = async (visitorId, { source = 'all', days = 30 } = {}) => {
  const response = await axios.get(`/admin/system-monitor/visitors/${encodeURIComponent(visitorId)}/history`, { params: { source, days } });
  return response.data;
};

export const fetchSystemUserHistory = async (userId, { source = 'all', days = 30 } = {}) => {
  const response = await axios.get(`/admin/system-monitor/users/${userId}/history`, { params: { source, days } });
  return response.data;
};

export const fetchBlockedSystemUsers = async () => {
  const response = await axios.get('/admin/system-monitor/blocked-users');
  return response.data;
};

export const blockSystemUser = async (userId, reason = '') => {
  const response = await axios.post(`/admin/system-monitor/users/${userId}/block`, { reason });
  return response.data;
};

export const unblockSystemUser = async (userId, reason = '') => {
  const response = await axios.post(`/admin/system-monitor/users/${userId}/unblock`, { reason });
  return response.data;
};

export const disconnectSystemUser = async (userId) => {
  const response = await axios.post(`/admin/system-monitor/users/${userId}/disconnect`);
  return response.data;
};

export const disconnectSystemConnection = async (socketId) => {
  const response = await axios.post(`/admin/system-monitor/connections/${encodeURIComponent(socketId)}/disconnect`);
  return response.data;
};
